// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__DK1y_","rotate":"styles_rotate__kN2S_","path":"styles_path__gVHKi","dash":"styles_dash__ElDKf"};